export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/yufukuanbaohan-631ae606d81b74c47f84d369f5909556.png";